import { Component, Input } from '@angular/core';
import { EfaCartItemListComponent } from '@shared/components/efa-cart-item-list/efa-cart-item-list.component';
import { OrderEntry } from '@spartacus/cart/base/root';
import { MiniCartItemComponent } from '../mini-cart-item/mini-cart-item.component';
import { SpinnerComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-mini-cart-item-list',
    templateUrl: './mini-cart-item-list.component.html',
    imports: [MiniCartItemComponent, SpinnerComponent, AsyncPipe, TranslatePipe]
})
export class MiniCartItemListComponent extends EfaCartItemListComponent {
  @Input() maxItemsToShow: number;
  showAllItems = false;

  toggleShowMore(): void {
    this.showAllItems = !this.showAllItems;
  }

  get lastItemIndexToShow(): number {
    let nomOfItemsInShow: number = 0;
    let lastItemIndexToShow: number;
    this.items.forEach((item: OrderEntry, index: number) => {
      if (!item.subEntry && !item.parent) {
        if (nomOfItemsInShow < this.maxItemsToShow) {
          nomOfItemsInShow = nomOfItemsInShow + 1;
          lastItemIndexToShow = index;
        }
      }
    }) 
    return lastItemIndexToShow;
  }

  get nomOfItemsToShow(): number {
    return this.items.filter((item: OrderEntry) => !item.subEntry && !item.parent).length;
  }
}
